module.exports = __webpack_public_path__ + "img/piranha-plant-min.d4c47437.png";